<template>
	<div v-if="show" class="wid100">
		<div v-if="datalist.length" class="drawerpage">

			<div class="contacts_tit Flexalcent">
				相关联系人
			</div>

			<div class="contacts_cotnent">
				<!--  -->
				<div class="contacts_item Flexalcent" v-for="(item,index) in datalist">
					<!--  -->
					<div class="lefte Flexalcent">
						<div class="img_boxz">
							<el-image style="width: 100%; height: 100%" :src="item.head_image" v-if="item.head_image"></el-image>
							<img v-else src="~assets/img/def_icon.png" alt="" style="width: 100%; height: 100%">
						</div>
						<div class="user_info">
							<div class="u_name Flexalcent">
								<div class="tit">
									{{item.name || ''}}
								</div>
								<div class="shuyu">
									<span style="color: rgb(39,165,56);margin-left: 5px;" v-if="drawerinfo.openid">
										@微信
									</span>
									<span style="color: #eda150;margin-left: 5px;" v-else-if="drawerinfo.external_userid">
										@企微
									</span>
								</div>
							</div>
							<div class="qy_name Flexalcent" v-if="drawerinfo.qy_name">
								<img :src="urlhead + '/renz1.png'">
								{{drawerinfo.qy_name || ''}}
							</div>
						</div>
					</div>
					<!--  -->
					<div class="rlines"></div>
					<!--  -->
					<div class="righte Flexalcent">
						<div class="te_info">
							<div class="te_span">
								手机：{{item.phone || '暂无'}}
							</div>
							<div class="te_span">
								最后跟进时间：{{item.follow_time || '暂无'}}
							</div>
						</div>
						<div class="icon_b" v-if="item.is_main == 1">
							<img :src="urlhead + '/icon_b1.png'">
						</div>
					
					</div>
					<!--  -->
					
				</div>
				<!--  -->
				
			</div>
			<!--  -->
		</div>
		
		<!-- 没有数据 -->
		<template v-else>
			<nodata :show="true"></nodata>
		</template>
		<!--  -->
	</div>
	
</template>

<script>
	var that
	import {


		lxrl_list_contact,


	} from 'network/hk_customer'


	import nodata from "@/components/content/publics/nodata.vue";
	export default {
		components: {
			nodata,
		},
		name: "relacuscontacts",
		props: {

			show: {
				type: Boolean,
				default: false,
			},
			customer_id: {
				type: Number,
				default: 0,
			},
			list: {
				type: Array,
				default: [],
			},
			drawerinfo: {
				type: Object,
				default: {},
			},
			
			


		},
		data() {
			return {
				//

				urlhead: 'https://scrm.51kuaiding.com/scrm/hktxcx/customer',
				datalist: [],


			}
		},

		created() {
			that = this


		},
		watch: {
			show() {
				if (this.show) {
					if (this.list.length) {
						this.datalist = this.list
					} else {
						this.getlists()
					}
				} else {
					this.datalist = []
				}
			},
		},

		methods: {

			getlists() {
				let data = {
					pagesize: 999,
					sort_type:1,
					class_type: 0,
				}
				if (this.customer_id) {
					data.customer_id = this.customer_id
				}
				// 获取 列表
				lxrl_list_contact(data).then(res => {
					if (this.handlereq(res)) {
						let obj = res.result.data
						this.handle_data(obj)
						if(obj.length){
							this.$emit('retunm', {num: obj.length})
							let arr = obj.filter(v=>v.is_main == 1)
							if(arr.length) {
								console.log(arr,'arr')
								this.$emit('retcontacs', {obj: arr[0]})
							}
						}
					}
					
					
				})
			},
			handle_data(data) {
				if (data) {
					for (let item of data) {

						item.checked = false
					}
					this.$nextTick(() => {
						this.datalist = data
						console.log(this.datalist, 'datalist')
					})

				}
			},







			// 弹出提示
			alertMess(message, type) {
				this.$message({
					showClose: true,
					offset: 100,
					duration: 2000,
					message,
					type: type ? type : 'success',
				});
			},
			handlereq(res) {
				if (res) {
					if (res.code === 10000) { // 请求成功
						return true
					} else { // 请求发生错误
						this.alertMess(res.message, 'error')
						return false
					}
				}
			},




		}
	}
</script>

<style scoped lang="scss">
	
	.Flexalcent {
		display: flex;
		align-items: center;
	}

	.contacts_tit {
		font-size: 16px;
		position: relative;
		color: rgba(56, 56, 56, 1);
		margin-bottom: 24px;
	}

	.contacts_tit::before {
		content: '';
		display: block;
		width: 3px;
		height: 20px;
		margin-right: 9px;
		background: rgba(43, 117, 235, 1);
	}

	.contacts_cotnent {
		width: 100%;

		.contacts_item {
			margin-bottom: 14px;
			width: 100%;
			max-width: 734px;
			min-height: 96px;
			border-radius: 5px;
			background: rgba(255, 255, 255, 1);
			padding: 15px 27px;
			border-right: solid 1px rgba(240, 240, 240, 1);
			.rlines{
				width: 1px;
				height: 66px;
				background-color: rgba(240, 240, 240, 1);
			}
			.lefte {
				width: 295px;
				// border-right: rgba(240, 240, 240, 1);
				.img_boxz {
					width: 46px;
					height: 46px;
					margin-right: 11px;
					overflow: hidden;
					border-radius: 5px;
				}

				.user_info {
					.u_name {
						margin-bottom: 8px;

						.tit {
							font-size: 18px;
							font-weight: 550;
							color: rgba(56, 56, 56, 1);
						}

						.shuyu {
							span {
								font-size: 14px;
							}
						}
					}

					.qy_name {

						font-size: 12px;
						color: rgba(150, 150, 150, 1);

						>img {
							width: 13px;
							height: 15px;
							margin-right: 8px;
							display: block;
						}
					}
				}
			}

			.righte {
				padding-left: 51px;
				flex: 1;
				justify-content: space-between;
				.te_info {
					.te_span {
						font-size: 13px;
						margin-bottom: 6px;
						color: rgba(150, 150, 150, 1);
					}

					
				}
				.icon_b {
					>img {
						width: 19px;
						height: 19px;
						display: block;
					}
				}
			}
		}
	}
</style>
